import { useQuery } from '@tanstack/react-query';
import QueryKeys from '../utils/QueryKeys';
import { Option } from '../models';

export default function useIndividualPrintOption() {
  return useQuery([QueryKeys.OPTIONS, QueryKeys.INDIVIDUAL_PRINTS], () => (
    Option
      .includes(['prices'])
      .where({ name: 'Individual Prints' })
      .first()
      .then((res) => res.data)
  ));
}
